import * as factory from './Request.Factory';
import cookie from "react-cookie";
import $ from 'jquery';


var config = require('../base/URL.Config').config();

/*
 GetToken
 
 Purpose:
 Gets the current token if it exists, removing first and last character (")
 
 @return (string) : The token string if it exists, else undefined
 
 @author Humberto Barrera <humberto@inclancommunications.com>
 
 */
export function GetToken()
{
    var token = cookie.load("inclanToken");
    var decoded_token = (token) ? decodeURI(cookie.load("inclanToken")).substr(1).slice(0, -1) : null;

    return decoded_token;
}

/*
 SetToken
 Purpose:
 Sets a token in the cookies with the config defined experation date and name
 @param token (string) : The value of the token to be set
 */
export function SetToken(token) {
    let name = "inclanToken";
    var now = new Date();
    now.setDate(now.getDate() + 5);
    cookie.save(name, token, {
        path: "/",
        domain: window.location.hostname,
        expires: now,
    });
}

export function Login(data) {

    var base = config.URL.API.BASE;
    var login_url = base + config.URL.API.USERS.login;

    var request = new factory.Request();

    var response = request.Post(login_url, data);
    return response;
}



// WEBPACK FOOTER //
// ./src/client/services/Auth.Service.js